export interface AddressLookupItem {
    Id: string;
    Type: string;
    Text: string;
    Highlight: string;
    Description: string;
}

export interface RetrieveItem {
    Company: string;
    District: string;
    BuildingName: string;
    BuildingNumber: string;
    Line1: string;
    Line2: string;
    Line3: string;
    Line4: string;
    Line5: string;
    City: string;
    ProvinceName: string;
    PostalCode: string;
    CountryName: string;
    CountryIso2: string;
    CountryIso3: string;
}

export function LookupAddress(searchTerm: string, apiKey: string, countryCode?: string) {
    return PerformLookup(searchTerm, apiKey, countryCode);
}

async function PerformLookup(text: string, apiKey: string, countryCode?: string, container?: string): Promise<AddressLookupItem[]> {

    let url = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';

    let params = '';
    params += '&Key=' + encodeURIComponent(apiKey);
    params += '&Text=' + encodeURIComponent(text);
    params += '&Language=en-gb';
    if (countryCode) {
        params += '&Countries=' + encodeURIComponent(countryCode);
    }
    
    if (container) {
        params += '&Container=' + encodeURIComponent(container);
    }

    const results: { Items: AddressLookupItem[] } = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
    }).then(response => {
        return response.json();
    });

    const containerResults = await Promise.all(
        results.Items
            .filter(i => i.Type === 'Postcode')
            .map(async (i) => await PerformLookup(text, apiKey, countryCode, i.Id)));

    const flattenedContainerResults = containerResults.reduce((a, b) => a.concat(b), []);

    return results
        .Items
        .concat(flattenedContainerResults)
        .filter(i => i.Type === 'Address');
}

export async function RetrieveAddress(id: string, apiKey: string): Promise<RetrieveItem> {
    let url = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1/json3.ws';

    let params = '';
    params += '&Key=' + encodeURIComponent(apiKey);
    params += '&Id=' + encodeURIComponent(id);

    const results: { Items: RetrieveItem[] } = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
    }).then(response => {
        return response.json();
    });

    return results.Items[0];
}

// tslint:disable-next-line: no-any
export async function AccountNumberAndSortCodeAPI(loqateAPIKey: string, accountNumber: string, sortCode: string): Promise<any> {
    let url = 'https://api.addressy.com/BankAccountValidation/Interactive/Validate/v2.00/json3.ws';

    let params = '';
    params += '&Key=' + encodeURIComponent(loqateAPIKey);
    params += '&AccountNumber=' + encodeURIComponent(accountNumber);
    params += '&SortCode=' + encodeURIComponent(sortCode);
    // tslint:disable-next-line: no-any
    const results: { Items: any[] } = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
    }).then(response => {
        return response.json();
    }).catch(error => {
        /* */
    });
    return results.Items[0];
}

// tslint:disable-next-line: no-any
export async function ValidateIBAN(loqateAPIKey: string, iban: string): Promise<any> {
    let url = 'https://api.addressy.com/InternationalBankValidation/Interactive/Validate/v1.00/json3.ws';

    let params = '';
    params += '&Key=' + encodeURIComponent(loqateAPIKey);
    params += '&IBAN=' + encodeURIComponent(iban);
    // tslint:disable-next-line: no-any
    let result: { Items: any[] }  = await fetch(url , {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params,
    }).then(response => {
        return response.json();
    }).catch(error => {
         /* */
    });
    return result.Items[0];
}


// WEBPACK FOOTER //
// ./src/Helpers/Loqate.ts